import React from "react";
import { CalendarDays } from "lucide-react";
import CashImg from "../../assets/images/svgs/other/cashHand.svg";

const Paycards = ({
  subTitle,
  description,
  orderImg,
  refId,
  orderNum,
  mealIcon,
  mealType,
  onHandleDetails,
  paymentType,
}) => {
  return (
    <section className="w-full">
      <div
        onClick={onHandleDetails}
        className="w-full bg-white rounded-xl border border-[#C0EBD1] p-4 sm:p-5 shadow-sm hover:shadow-md transition-all duration-200"
      >
        <div className="cursor-pointer space-y-4">
          {/* Description + Price */}
          <div className="flex  flex-row  justify-between   gap-2">
            <p className="flex items-start gap-2 text-sm sm:text-base text-[#606060] leading-relaxed">
              <CalendarDays size={18} className="mt-[2px]" />
              <span>{description}</span>
            </p>

            <p className="text-base font-semibold text-[#FF6943]">{subTitle}</p>
          </div>
          <p className="flex items-start mt-2 gap-2 text-sm   text-[#606060] leading-relaxed">
            {refId}
          </p>

          {/* For Cash */}

          <div className="flex   justify-between gap-3 pt-2">
            <div className="flex items-center gap-2">
              <img src={CashImg} alt="order" className="w-5 h-5" />
              <p className="text-sm text-start text-gray-500">{paymentType}</p>
            </div>

            <div className="flex items-center gap-2">
              <p className=" rounded-full p-2 flex justify-center items-center text-xs font-normal text-[#29B067] bg-[#E1F4EA]">
                Successfull
              </p>
            </div>
          </div>

          {/* For Online */}
          {/*            
            <div className="flex flex-wrap items-center justify-start gap-3 pt-2">
              <span className="flex items-center  gap-2 rounded-full bg-gray-200 px-3 py-1 text-sm text-[#191919]">
                {mealIcon}
                <p className="text-xs">{mealType}</p>
              </span>
              <div className="flex items-center gap-2">
                <img src={orderImg} alt="order" className="w-4 h-4" />
                <p className="text-sm font-normal">{orderNum}</p>
              </div>
              <div className="flex items-center gap-2">
                <img src={CashImg} alt="order" className="w-4 h-4" />
                <p className="text-xs text-start text-gray-500">Online</p>
              </div>

              <p className=" rounded-full p-2 flex justify-center items-center text-xs font-normal text-[#29B067] bg-[#E1F4EA]">
                Successfull
              </p>
            </div> */}
        </div>
      </div>
    </section>
  );
};

export default Paycards;
